// src/scripts/contact/internal/init.js

import { isBrowser, CONTACT_LOADED_KEY } from './constants.js';
import { getInstance, setInstance, isInitialized, setInitialized } from './state.js';
import { waitForDOMReady } from './domReady.js';
import { loadContactDependencies } from './dependencies.js';

export async function initializeContactSystem() {
  if (!isBrowser) throw new Error('SSR—cannot initialize');
  if (isInitialized()) return getInstance();
  if (window[CONTACT_LOADED_KEY]) throw new Error('Contact system already loaded');

  await waitForDOMReady();
  await loadContactDependencies();

  const module = await import('../core/ContactNamespace.js');
  const ContactNamespace = module.default || module;
  const inst = ContactNamespace.getInstance();
  if (typeof inst.init === 'function') await inst.init();

  setInstance(inst);
  setInitialized(true);
  window[CONTACT_LOADED_KEY] = true;
  window.ContactSystem = inst;
  return inst;
}